var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDnd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.882,
    height: 63.998,
    viewBox: "0 0 35.882 63.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "do-not-disturb_3_",
    "data-name": "DND",
    transform: "translate(-112.467 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36048",
    "data-name": "Path 36048",
    d: "M236.258,303.134a6.119,6.119,0,0,0-2.82.687l8.292,8.292a6.156,6.156,0,0,0-5.472-8.978Z",
    transform: "translate(-105.85 -265.243)",
    fill: "#6d6d6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36049",
    "data-name": "Path 36049",
    d: "M206.734,332.66a6.154,6.154,0,0,0,8.978,5.472l-8.292-8.292A6.119,6.119,0,0,0,206.734,332.66Z",
    transform: "translate(-82.484 -288.611)",
    fill: "#6d6d6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36050",
    "data-name": "Path 36050",
    d: "M130.408,0a17.961,17.961,0,0,0-17.941,17.941,1.875,1.875,0,0,0,1.875,1.875h8.033a1.875,1.875,0,0,0,1.875-1.875,6.158,6.158,0,1,1,6.158,6.158H119.363a6.9,6.9,0,0,0-6.9,6.9V57.1a6.9,6.9,0,0,0,6.9,6.9h22.091a6.9,6.9,0,0,0,6.9-6.9V17.941A17.962,17.962,0,0,0,130.408,0Zm0,53.957a9.908,9.908,0,1,1,9.908-9.908A9.919,9.919,0,0,1,130.408,53.957Z",
    transform: "translate(0 0)",
    fill: "#6d6d6d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnd);
export default __webpack_public_path__ + "static/media/DND.34e8961267882b9a0e5083bd015ec415.svg";
export { ForwardRef as ReactComponent };